<template>
  <v-row class="fill-height w-100" style="margin: 0">
    <v-col>
      <div class="top-toolbar">
        <v-sheet>
          <div class="d-flex align-center justify-space-between py-2 px-2">
            <div class="d-flex align-center mr-5">
              <div style="color: #ffb300" class="mr-0 mr-md-4">
                {{ startDateMoment.format('DD/MM/YYYY') }}
                -
                {{ endDateMoment.format('DD/MM/YYYY') }}
              </div>
              <v-btn :disabled="loading" icon small color="grey darken-2" @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn :disabled="loading" icon small color="grey darken-2" @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <RoomLegend
              :rooms="roomsWithColor"
              class="mr-5"
              v-if="!showMobileRoomLegend"
            ></RoomLegend>
            <div style="text-align: right" class="d-flex align-center">
              <!-- ref="menu"
                v-model="menu" -->
              <!-- :return-value.sync="date" -->
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
                offset-y
                class="mr-2"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details
                    outlined
                    :value="monthString"
                    readonly
                    dense
                    append-icon="keyboard_arrow_down"
                    v-bind="attrs"
                    v-on="on"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :value="startDateMoment.toISOString()"
                  @input="onChangeMonth($event)"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-btn text color="primary" @click="onClickGoToCurrent"> Hiện tại </v-btn>
                  <v-spacer></v-spacer>
                  <!-- <v-btn text color="primary" @click="menu = false"> Hủy </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn> -->
                </v-date-picker>
              </v-menu>
              <ScheduleFilter
                v-if="shouldShowFilter"
                :allCourses="allCourses"
                :allMajors="allMajors"
                :allTeachers="allTeachers"
                :allRooms="allRooms"
                :allGenerations="allGenerations"
                :allClasses="allClasses"
                @onFilterChanged="onFilterChanged"
                class="ml-2"
              ></ScheduleFilter>
            </div>
          </div>
        </v-sheet>
        <RoomLegend :rooms="roomsWithColor" v-if="showMobileRoomLegend" class="pa-2"></RoomLegend>
      </div>

      <v-sheet>
        <week-calendar
          class="mb-4 border"
          v-for="i in eventGroups"
          :key="i.start.toISOString()"
          :config="{ start: i.start, end: i.end }"
          :events="i.events"
          @click:event="showEvent"
          :loading="loading"
          :weekIndex="i.weekIndex"
        />
        <v-dialog
          :fullscreen="$vuetify.breakpoint.mobile"
          v-model="selectedOpen"
          :max-width="320"
          offset-x
        >
          <slot-card :data="selectedEvent.data" @close="onClose"></slot-card>
        </v-dialog>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import lodash from 'lodash'
import moment from 'moment'
import SlotCard from '@/modules/dashboard/SlotCard.vue'
import WeekCalendar from '@/components/basic/calendar/WeekCalendar'
import RoomLegend from './RoomLegend.vue'
import { colors } from '../../constants/index.js'
import ScheduleFilter from '../teacher/ScheduleFilter.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    SlotCard,
    WeekCalendar,
    RoomLegend,
    ScheduleFilter
  },
  data: () => ({
    // menu: '',
    // date: moment().format('YYYY-MM'),
    focus: '',
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    startWeek: moment().startOf('week'),
    endWeek: moment().endOf('week'),
    selectedMajor: undefined,
    selectedCourse: undefined,
    selectedTeacher: undefined,
    selectedRoom: undefined,
    selectedCategory: undefined,
    selectedClass: undefined,
    selectedGeneration: undefined
  }),
  computed: {
    ...mapState('rooms', ['rooms']),
    ...mapGetters('auth', ['user']),

    showMobileRoomLegend() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return false
      }
      return true
    },
    startDateMoment() {
      return moment(this.startDate)
    },
    endDateMoment() {
      return moment(this.endDate)
    },
    monthString() {
      if (this.startDateMoment.get('month') === this.endDateMoment.get('month')) {
        return 'Tháng ' + (this.startDateMoment.get('month') + 1)
      } else {
        return (
          'T' +
          this.startDateMoment.format(`MM`) +
          ' và T' +
          moment(this.endDateMoment).format(`MM`) +
          ' ' +
          this.startDateMoment.format(`YYYY`)
        )
      }
    },
    roomsWithColor() {
      return Object.entries(this.rooms)
        .map(([k, v], index) => {
          const color = colors[index]
          return { ...v, color }
        })
        .sort((a, b) => (a.index || 0) - (b.index || 0))
    },

    shouldShowFilter() {
      if (!(this.user || {}).role) {
        return false
      }
      if (
        ['manager', 'accountant', 'education_manager', 'super_admin', 'teacher'].includes(
          this.user.role.type
        )
      ) {
        return true
      }
      return false
    },
    allMajors() {
      if (!this.slots) {
        return []
      }
      return _.uniq(this.slots.map(i => _.get(i, 'class.major')))
    },
    allCourses() {
      if (!this.slots) {
        return []
      }
      return _.uniq(this.slots.map(i => _.get(i, 'class.course')))
    },
    allTeachers() {
      if (!this.slots) {
        return []
      }
      const output = _.uniq(
        this.slots
          .map(i =>
            _.get(i, 'teachers', [])
              .concat(..._.get(i, 'mentors', []))
              .concat(..._.get(i, 'class.grading_teachers', []))
          )
          .flat()
          .map(i => _.get(i, '_id', i))
      )

      return output
    },
    allRooms() {
      if (!this.slots) {
        return []
      }
      return _.uniq(this.slots.map(i => _.get(i, 'room.id', [])))
    },
    allClasses() {
      if (!this.slots) {
        return []
      }
      const output = _.uniq(
        this.slots
          .map(i => _.get(i, 'class.tags', '').split(/,\s*/))
          .flat()
          .filter(Boolean)
      )
        .sort()
        .map(i => ({ title: i, id: i }))
      return output
    },
    allGenerations() {
      if (!this.slots) {
        return []
      }
      return _.uniq(this.slots.map(i => _.get(i, 'class.generation', [])))
    },

    filteredSlots() {
      if (!this.slots) {
        return this.slots
      }
      if (
        !this.selectedMajor &&
        !this.selectedCourse &&
        !this.selectedTeacher &&
        !this.selectedCategory &&
        !this.selectedClass &&
        !this.selectedGeneration &&
        !this.selectedRoom
      ) {
        return this.slots
      }
      let output = this.slots.map(i => i)
      if (this.selectedRoom) {
        output = output.filter(i => _.get(i, 'room.id') === this.selectedRoom)
      }
      if (this.selectedGeneration) {
        output = output.filter(i => _.get(i, 'class.generation') === this.selectedGeneration)
      }
      if (this.selectedMajor) {
        output = output.filter(i => _.get(i, 'class.major') === this.selectedMajor)
      }
      if (this.selectedCourse) {
        output = output.filter(i => _.get(i, 'class.course') === this.selectedCourse)
      }
      if (this.selectedClass) {
        output = output.filter(i => {
          return (i.class.tags || '').split(/,\s*/).includes(this.selectedClass)
        })
      }
      if (this.selectedTeacher) {
        output = output.filter(
          i =>
            // _.get(i, 'class.teachers', []).includes(this.selectedTeacher) ||
            // _.get(i, 'class.mentors', []).includes(this.selectedTeacher) ||
            // _.get(i, 'class.grading_teachers', []).includes(this.selectedTeacher) ||
            _.get(i, 'teachers', []).find(j => j.id === this.selectedTeacher) ||
            _.get(i, 'mentors', []).find(j => j.id === this.selectedTeacher)
        )
      }
      if (this.selectedCategory) {
        output = output.filter(i => _.get(i, 'category') === this.selectedCategory)
      }

      return output
    },
    events() {
      return this.filteredSlots.map(s => {
        return {
          name: _.get(s, 'class.code'),
          start: moment(s.startTime).format(`YYYY-MM-DD`),
          color:
            moment(s.startTime).hour() < 12
              ? 'green'
              : moment(s.startTime).hour() < 18
              ? 'orange'
              : '#727272',
          data: s,
          timestamp: moment(s.startTime).format(`YYYY-MM-DD HH:mm`),
          timed: false
        }
      })
    },
    eventGroups() {
      const roomToColorMap = Object.fromEntries(
        this.roomsWithColor.map(({ id, color }) => [id, color])
      )
      const eventsGrouped = lodash.groupBy(
        this.filteredSlots.map(s => {
          const startTime = moment(s.startTime)
          let color
          try {
            color = roomToColorMap[s.room.id]
          } catch (error) {
            console.error(error)
          }
          return {
            week: startTime.week(),
            name: lodash.get(s, 'class.code'),
            start: startTime.format(`YYYY-MM-DD`),
            color,
            data: { ...s, color },
            timestamp: startTime.format(`YYYY-MM-DD HH:mm`),
            timed: false
          }
        }),
        i => `${i.week}_`
      )

      const eventsArr = Object.entries(eventsGrouped)
        .map(([k, events], index) => {
          const weekIndex = parseInt(k)
          const startTimeOfFirst = events[0].start
          const start = moment(startTimeOfFirst).startOf('week')
          const end = moment(startTimeOfFirst).endOf('week')
          return { weekIndex, events, start, end }
        })
        .sort((a, b) => a.weekIndex - b.weekIndex)

      let outputTemplate = Array(4)
        .fill(0)
        .map((_, index) => {
          const start = this.startDateMoment.clone().add(index, 'week').startOf('week')
          const end = start.clone().endOf('week')

          return {
            weekIndex: start.week(),
            start,
            end,
            events: []
          }
        })

      const output = outputTemplate.map(j => {
        const match = eventsArr.find(i => i.weekIndex === j.weekIndex)
        return match || j
      })
      console.log({ output, eventsArr, outputTemplate })
      return output
    }
  },

  watch: {
    date(val, old) {
      this.startWeek = moment(val, 'YYYY-MM').startOf('week')
      this.endWeek = this.startWeek.clone().endOf('week')
      this.updateRange({
        start: this.startWeek,
        end: this.endWeek
      })
    }
  },
  props: {
    slots: Array,
    count: Number,
    add: Boolean,
    remove: Boolean,
    headers: Array,
    loading: Boolean,
    startDate: String,
    endDate: String
  },
  methods: {
    ...mapActions('rooms', ['fetchRooms']),
    onChangeMonth($e) {
      const start = moment($e).startOf('week')
      const end = moment($e).endOf('week').add(3, 'week')
      this.updateRange({ start: start, end: end })
    },
    onFilterChanged(payload) {
      const { major, course, teacher, room, category, slotClass, generation } = payload
      if (major) {
        this.selectedMajor = major
      } else {
        this.selectedMajor = undefined
      }
      if (course) {
        this.selectedCourse = course
      } else {
        this.selectedCourse = undefined
      }
      if (teacher) {
        this.selectedTeacher = teacher
      } else {
        this.selectedTeacher = undefined
      }
      if (room) {
        this.selectedRoom = room
      } else {
        this.selectedRoom = undefined
      }
      if (category) {
        this.selectedCategory = category
      } else {
        this.selectedCategory = undefined
      }
      if (generation) {
        this.selectedGeneration = generation
      } else {
        this.selectedGeneration = undefined
      }
      if (slotClass) {
        this.selectedClass = slotClass
      } else {
        this.selectedClass = undefined
      }
    },
    next() {
      // this.startWeek = this.startWeek.add(1, 'week').clone()
      // this.endWeek = this.endWeek.add(1, 'week').clone()
      this.updateRange({
        start: this.startDateMoment.add(4, 'week'),
        end: this.endDateMoment.add(4, 'week')
      })
    },
    prev() {
      this.updateRange({
        start: this.startDateMoment.subtract(4, 'week'),
        end: this.endDateMoment.subtract(4, 'week')
      })
    },
    showEvent({ nativeEvent, event }) {
      this.selectedEvent = event
      this.selectedElement = nativeEvent.target
      this.selectedOpen = true
      nativeEvent.stopPropagation()
    },
    updateRange({ start, end }) {
      this.$emit('change', { start, end })
    },
    // convertDateToString(date) {
    //   if (moment(this.startWeek).format(`MM YYYY`) === moment(this.endWeek).format(`MM YYYY`)) {
    //     return 'Tháng ' + moment(this.startWeek).format(`MM YYYY`)
    //   } else {
    //     return (
    //       'T' +
    //       moment(this.startWeek).format(`MM`) +
    //       ' và T' +
    //       moment(this.endWeek).format(`MM`) +
    //       ' ' +
    //       moment(this.startWeek).format(`YYYY`)
    //     )
    //   }
    // },
    onClickGoToCurrent() {
      const start = moment().startOf('week')
      const end = moment().endOf('week').add(3, 'week')

      this.updateRange({
        start,
        end
      })
    },
    onClose() {
      console.log('close ne')
      this.selectedOpen = false
    }
  },
  created() {
    this.fetchRooms()
  }
}
</script>
<style scoped lang="scss">
.top-toolbar {
  position: sticky;
  top: -8px;
  z-index: 1;
}
</style>
